<template>
    <div>
        <h2 class="text-sm font-medium text-gray-700 mb-1">Activity</h2>
        <div class="bg-gray-50 border border-gray-200 rounded-xl p-4">
            <div class="space-y-4">
                <ui-dropdown-date :moment="estimate.created_at_moment" menu-class="p-3 w-52" #default="{ open, close, dateAgo }">
                    <div class="flex items-center text-sm text-gray-500" @mouseenter="open" @mouseleave="close">
                        <i class="fas fa-calendar fa-fw text-gray-400 flex-shrink-0 text-sm mr-1.5"></i>
                        Created {{ dateAgo }} by {{ estimate.created_by }}
                    </div>
                </ui-dropdown-date>
                <ui-dropdown-date :moment="estimate.updated_at_moment" menu-class="p-3 w-52" #default="{ open, close, dateAgo }">
                    <div class="flex items-center text-sm text-gray-500" @mouseenter="open" @mouseleave="close">
                        <i class="fas fa-calendar-edit fa-fw text-gray-400 flex-shrink-0 text-sm mr-1.5"></i>
                        Updated {{ dateAgo }} by {{ estimate.updated_by }}
                    </div>
                </ui-dropdown-date>
            </div>
            <remote-invite-list v-if="estimate.id" :invites="$store.state.remoteInvites"></remote-invite-list>
        </div>
    </div>
</template>

<script>
import { estimateStore } from '@stores'

export default {
    computed: {
        $store () {
            return estimateStore
        },
        estimate () {
            return this.$store.state.estimate
        },
    },
}
</script>
